// @scripts
import initialState from "./initial-state.json";

export default initialState;
